export default "__VITE_ASSET__BBmwIWff__"